import React, { useState, useEffect } from 'react';
import AppTopNav from './components/AppTopNav';
import BrowsePage from './features/browse/BrowsePage';
import SearchPage from './features/search/SearchPage';
import SignUpPage from './features/auth/SignUpPage';
import SignInPage from './features/auth/SignInPage';
import { supabase } from './lib/supabase';
import ChatPage from './features/chat/ChatPage';
import LandingPage from './features/marketing/LandingPage';
import ListsPage from './features/lists/ListsPage';

const NO_CHROME_PAGES = ['landing', 'signup', 'signin'];

function App() {
  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setActiveTab(session ? 'home' : 'landing');
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!session) setActiveTab('landing');
    });

    return () => subscription.unsubscribe();
  }, []);

  if (activeTab === null) return null;

  const isAuthPage = NO_CHROME_PAGES.includes(activeTab);

  async function handleSignOut() {
    await supabase.auth.signOut();
  }

  return (
    <div className="min-h-screen bg-surface-page flex flex-col">
      {!isAuthPage && (
        <AppTopNav activeTab={activeTab} onTabChange={setActiveTab} onSignOut={handleSignOut} />
      )}
      <div id="app-scroll-container" className={`flex-1 overflow-y-auto ${!isAuthPage ? 'pt-[62px]' : ''}`}>
        {activeTab === 'landing' && <LandingPage onNavigate={setActiveTab} />}
        {activeTab === 'signin' && <SignInPage onNavigate={setActiveTab} />}
        {activeTab === 'signup' && <SignUpPage onNavigate={setActiveTab} />}
        {activeTab === 'home' && <BrowsePage onNavigate={setActiveTab} />}
        {activeTab === 'search' && <SearchPage onNavigate={setActiveTab} />}
        {activeTab === 'lists' && <ListsPage onNavigate={setActiveTab} />}
        {activeTab === 'chat' && <ChatPage />}
      </div>
    </div>
  );
}

export default App;
